import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import { SVGICON } from "../../../constant/theme";
import {
  ActiveInactive_Record,
  delete_Record,
  errorMessage,
} from "../CommonFunctions";
import CustomSizePerPage from "../../../CustomControls/CustomSizePerPage";
import CustomPaginationButtons from "../../../CustomControls/CustomPaginationButtons";
import { post } from "../../../helpers/api_helper";
import swal from "sweetalert";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomSelect from "../../../CustomControls/CustomSelect";
import {
  POST_GetProductGroupsList,
  POST_ProductGroupsActiveInActive,
  POST_ProductGroupsDelete,
  POST_ProductGroupsExport,
} from "../../../helpers/url_helper";
import { useFilter } from "../../../../context/FilterContext";

const ProductGroup = () => {
  const [showFilter, setShowFilter] = useState(false);
  const { filter, updateFilter } = useFilter();

  const [isLoading, setIsLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(
    filter && filter?.page == "product-groups" ? filter?.CurrentPage : 1
  );
  const [currentSizePerPage, setCurrentSizePerPage] = useState(
    filter && filter?.page == "product-groups" ? filter?.PageSize : 10
  );
  const [recordCount, setRecordCount] = useState(0);
  const [sortBy, setSortBy] = useState(
    filter && filter?.page == "product-groups" ? filter?.sortBy : ""
  );
  const [orderBy, setOrderBy] = useState(
    filter && filter?.page == "product-groups" ? filter?.orderBy : "asc"
  );

  const [isReset, setIsReset] = useState(false);

  const [productGroupList, setProductGroupList] = useState([]);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const handleClickSorting = (columnName) => {
    setCurrentPage(1);
    if (sortBy == columnName) {
      if (orderBy == "asc") {
        setOrderBy("desc");
      } else {
        setSortBy("");
        setOrderBy("asc");
      }
    } else {
      setSortBy(columnName);
      setOrderBy("asc");
    }
  };

  const statusOptions = [
    { label: "All", value: -1 },
    { label: "Active", value: 1 },
    { label: "Inactive", value: 0 },
  ];

  const validationSchema = Yup.object().shape({});

  const formikFilter = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      Status: filter && filter?.page == "product-groups" ? filter?.Status : -1,
      Search: filter && filter?.page == "product-groups" ? filter?.Search : "",
      // Search: "",
      // Status: -1,
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmit,
    values: { Search, Status },
  } = formikFilter;

  const getResetData = async () => {
    setIsLoading(true);

    // formikFilter.resetForm();
    formikFilter.setValues({
      Status: -1,
      Search: "",
    });

    setCurrentPage(1);
    setSortBy("");
    setOrderBy("asc");

    setIsReset(true);
  };

  const getData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);

    updateFilter({
      page: "product-groups",
      CurrentPage: page,
      PageSize: sizePerPage,
      sortBy: sortBy,
      orderBy: orderBy,
      Status: Status,
      Search: Search ? Search : "",
    });

    let payload = {
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: Search,
      Sorting: sortBy ? sortBy + " " + orderBy : "",
      Status: Status,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    };
    await post(POST_GetProductGroupsList, payload)
      .then((response) => {
        setRecordCount(response?.TotalRecordCount);
        setProductGroupList(response?.ProductGroupsList);
        setIsLoading(false);
        if (page > 1 && response?.ProductGroupsList?.length === 0) {
          setCurrentPage(page - 1);
          getData(page - 1, sizePerPage);
        } else {
          setCurrentPage(page);
        }
        setCurrentSizePerPage(sizePerPage);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const fnCallback = () => {
    getData(currentPage, currentSizePerPage);
  };

  useEffect(() => {
    getData(1, currentSizePerPage);
  }, [sortBy, orderBy]);

  useEffect(() => {
    if (isReset == true) {
      getData(currentPage, currentSizePerPage);
      setIsReset(false);
    }
  }, [isReset]);

  const exportReport = () => {
    setIsLoading(true);
    let payload = {
      Search: Search,
      Status: Status,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    };
    post(POST_ProductGroupsExport, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          window.open(response?.FilePath);
        } else {
          // swal("Error!", response?.Message, "error");
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="table-responsive active-projects style-1 shorting">
            <div className="tbl-caption p-2">
              <h4 className="heading mb-0">Material Group</h4>
              <div className="d-flex align-items-center">
                <button
                  type="button"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={(e) => {
                    getResetData();
                  }}
                >
                  <i className="fa fa-window-restore" aria-hidden="true"></i>
                  {"  "}
                  Reset
                </button>
                <button
                  type="button"
                  // className="btn btn-primary btn-sm me-2"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={(e) => {
                    getData();
                    // setShowFilter(false);
                  }}
                >
                  <i className="fa-solid fa-refresh me-2"></i> Reload
                </button>
                <button
                  type="button"
                  // className="btn btn-primary btn-sm me-2"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={() => setShowFilter(!showFilter)}
                >
                  <i className="fa-solid fa-filter me-2"></i>Filter
                </button>
                {AuthUser?.UserType !== 1 ||
                formsList?.filter((x) => x?.FormID == 19 && x?.IsExport)
                  ?.length > 0 ? (
                  <Link
                    // className="btn btn-primary light btn-sm me-2"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={exportReport}
                  >
                    <i className="fa-solid fa-file-excel" /> Export Report
                  </Link>
                ) : (
                  ""
                )}
                {AuthUser?.UserType !== 1 ||
                formsList?.filter((x) => x?.FormID == 19 && x?.IsAdd)?.length >
                  0 ? (
                  <Link
                    to="/add-product-group"
                    // className="btn btn-primary btn-sm"
                    className="btn btn-outline-primary btn-sm"
                  >
                    <i className="fa-solid fa-plus"></i> Add Material Group
                  </Link>
                ) : (
                  ""
                )}
              </div>
            </div>
            <hr className="mt-0 mb-1"></hr>
            <div className="p-2 pt-0 pb-0">
              {showFilter ? (
                <div>
                  <FormikProvider value={formikFilter}>
                    <Form onSubmit={formikFilter.handleSubmit}>
                      <Row className="me-0">
                        <Col lg={3}>
                          <Field
                            label="Search"
                            name="Search"
                            placeholder={"Search here..."}
                            component={CustomInput}
                          />
                        </Col>
                        <Col lg={3}>
                          <Field
                            label="Status"
                            name="Status"
                            placeholder={"Select Status"}
                            options={statusOptions}
                            component={CustomSelect}
                            isClearable={false}
                            menuPosition="fixed"
                          />
                        </Col>
                        <Col lg={3}>
                          <label className="mb-1">&nbsp;</label>
                          <div className="d-flex">
                            <div className="d-lg-block">
                              <Link
                                // className="btn btn-primary btn-sm mb-1"
                                className="btn btn-primary btn-sm"
                                onClick={(e) => {
                                  getData();
                                }}
                              >
                                <i className="fa fa-search" aria-hidden="true"></i>
                                {"  "}
                                Search
                              </Link>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </FormikProvider>
                </div>
              ) : (
                ""
              )}
              <div
                id="ProductGroup-tbl_wrapper"
                className="dataTables_wrapper no-footer"
              >
                <table
                  id="ProductGroup-tbl"
                  className="table dataTable no-footer mb-0"
                >
                  <thead>
                    <tr>
                      <th width="6%"></th>
                      <th
                        style={{
                          width: "34%",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleClickSorting("ProductGroupName");
                        }}
                      >
                        Material Group Name{" "}
                        <span className="ml-1">
                          {sortBy == "ProductGroupName" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th>
                      <th
                        style={{
                          width: "60%",
                          cursor: "pointer",
                          textAlign: "left",
                        }}
                        onClick={() => {
                          handleClickSorting("Departments");
                        }}
                      >
                        Departments{" "}
                        <span className="ml-1">
                          {sortBy == "Departments" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {productGroupList?.length > 0 ? (
                      productGroupList?.map((item, indx) => (
                        <tr key={indx}>
                          <td>
                            {AuthUser?.UserType !== 1 ||
                            formsList?.filter(
                              (x) => x?.FormID == 19 && x?.IsEdit
                            )?.length > 0 ? (
                              <Link
                                to={`/edit-product-group/${window.btoa(
                                  item.ProductGroupIDEncrypt
                                )}`}
                                // className="icon-box icon-box-md bg-primary-light me-1"
                                className="icon-box icon-box-md me-1"
                                title="Edit"
                              >
                                {SVGICON.EditPrimary}
                              </Link>
                            ) : (
                              ""
                            )}
                            {AuthUser?.UserType !== 1 ||
                            formsList?.filter(
                              (x) => x?.FormID == 19 && x?.IsActive
                            )?.length > 0 ? (
                              <Link
                                to="#"
                                // className={`icon-box icon-box-md bg-${
                                //   item.IsActive == true ? "success" : "danger"
                                // }-light me-1`}
                                className={`icon-box icon-box-md me-1`}
                                title={
                                  item.IsActive == true ? "Active" : "Inactive"
                                }
                                onClick={() => {
                                  ActiveInactive_Record(
                                    item.IsActive,
                                    POST_ProductGroupsActiveInActive,
                                    {
                                      ProductGroupIDEncrypt:
                                        item.ProductGroupIDEncrypt,
                                      IsActive: !item.IsActive,
                                      ModifiedByEncrypted:
                                        AuthUser?.ReferenceIDEncrypt
                                          ? AuthUser?.ReferenceIDEncrypt
                                          : "0",
                                    },
                                    setIsLoading,
                                    fnCallback,
                                    item.ProductGroupName
                                  );
                                }}
                              >
                                <i
                                  className={`fa fa-circle fs-15 ${
                                    item.IsActive == true
                                      ? "text-success"
                                      : "text-danger"
                                  }`}
                                ></i>
                              </Link>
                            ) : (
                              ""
                            )}
                            {AuthUser?.UserType !== 1 ||
                            formsList?.filter(
                              (x) => x?.FormID == 19 && x?.IsDelete
                            )?.length > 0 ? (
                              <Link
                                to="#"
                                // className="icon-box icon-box-md bg-danger-light"
                                className="icon-box icon-box-md me-1"
                                title="Delete"
                                onClick={() => {
                                  delete_Record(
                                    POST_ProductGroupsDelete,
                                    {
                                      ProductGroupIDEncrypt:
                                        item.ProductGroupIDEncrypt,
                                      ModifiedByEncrypted:
                                        AuthUser?.ReferenceIDEncrypt
                                          ? AuthUser?.ReferenceIDEncrypt
                                          : "0",
                                    },
                                    setIsLoading,
                                    fnCallback,
                                    item.ProductGroupName
                                  );
                                }}
                              >
                                {SVGICON.DeleteDanger}
                              </Link>
                            ) : (
                              ""
                            )}
                          </td>
                          <td>{item.ProductGroupName}</td>

                          <td
                            style={{ cursor: "pointer", textAlign: "left" }}
                            className="popupOverlay"
                          >
                            <OverlayTrigger
                              trigger={['hover', 'focus']}
                              key={indx}
                              responsive={true}
                              overlay={
                                <Tooltip className="toltip-popover">
                                  <strong className="p-1">
                                    {item.Departments}
                                  </strong>
                                </Tooltip>
                              }
                            >
                              <span>{item.Departments}</span>
                            </OverlayTrigger>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={3} style={{ textAlign: "left" }}>
                          <div>{"No Record Found..."}</div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className="d-sm-flex text-center justify-content-between align-items-center">
                  <CustomSizePerPage
                    getData={getData}
                    currentSizePerPage={currentSizePerPage}
                  />
                  <div className="dataTables_info">
                    Showing{" "}
                    {recordCount > 0
                      ? (currentPage - 1) * currentSizePerPage + 1
                      : 0}{" "}
                    to{" "}
                    {recordCount > currentPage * currentSizePerPage
                      ? currentPage * currentSizePerPage
                      : recordCount}{" "}
                    of {recordCount} entries
                  </div>
                  <CustomPaginationButtons
                    totalPages={recordCount / currentSizePerPage}
                    currentPage={currentPage}
                    currentSizePerPage={currentSizePerPage}
                    getData={getData}
                  />
                </div>
              </div>
            </div>
          </div>
        </Spin>
      </div>
    </div>
  );
};

export default ProductGroup;
